import { cx } from "@suse-o11y/class-variance";
import React from "react";

import styles from "./_dropdown-menu.module.css";

const LazySeparator = React.lazy(async () => {
	// biome-ignore lint/style/noRestrictedImports: component usage
	const { Separator } = await import("@radix-ui/react-dropdown-menu");

	return { default: Separator };
});

type DropdownMenuSeparatorProps = React.ComponentProps<typeof LazySeparator>;

export const DropdownMenuSeparator = React.forwardRef<
	React.ComponentRef<typeof LazySeparator>,
	DropdownMenuSeparatorProps
>(({ className, ...props }, ref) => <LazySeparator className={cx(styles.separator, className)} ref={ref} {...props} />);

if (import.meta.env.DEV) {
	DropdownMenuSeparator.displayName = "DropdownMenuSeparator";
}
